import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import CodeEditor from 'dashboard/components-lib/CodeEditor';
import { CaseVariableDefinitionAttributes } from 'dashboard/models/case-variable-definition';
import { ExternalIntegrationDataSource } from 'dashboard/models/external-integration';
import { toBase64WithUnicode, toStringFromBase64WithUnicode } from 'lib/base64';

const CodeEditorWrapper = styled.div`
  height: 250px;
`;

interface SnowflakeQueryEditorProps {
  control: Control<CaseVariableDefinitionAttributes, object>;
  selectedDataSource: ExternalIntegrationDataSource | undefined;
}

const SnowflakeQueryEditor: FC<SnowflakeQueryEditorProps> = ({ control, selectedDataSource }) => {
  return (
    <>
      <FormControlLabel id='snowflake_query_editor-sql-label'>Run SQL</FormControlLabel>
      <Controller
        name='variable-definition.sql'
        control={control}
        render={({ field: { value, onChange } }) => (
          <CodeEditorWrapper>
            <CodeEditor
              aria-labelledby='snowflake_query_editor-sql-label'
              code={value ? toStringFromBase64WithUnicode(value) : ''}
              language='sql'
              editable={true}
              schemas={{
                sql: {
                  tables: selectedDataSource?.attributes.schema?.tables || [],
                },
              }}
              onChange={(newSql) => onChange(toBase64WithUnicode(newSql))}
            />
          </CodeEditorWrapper>
        )}
      />
    </>
  );
};

export default SnowflakeQueryEditor;
